import Toast from './Toast';
import type { ToastProps } from './Toast';

export type ToastPosition =
  | 'top-left'
  | 'top-center'
  | 'top-right'
  | 'bottom-left'
  | 'bottom-center'
  | 'bottom-right';

interface ToastContainerProps {
  toasts: ToastProps[];
  position?: ToastPosition;
  onRemoveToast: (id: string) => void;
}

const positionClasses: Record<ToastPosition, string> = {
  'top-left': 'top-4 left-4 right-4 lg:top-8 lg:left-8 lg:right-auto',
  'top-center': 'top-4 left-1/2 -translate-x-1/2 lg:top-8',
  'top-right': 'top-4 right-4 lg:top-8 lg:right-8',
  'bottom-left': 'bottom-4 left-4 lg:bottom-8 lg:left-8',
  'bottom-center': 'bottom-4 left-1/2 -translate-x-1/2 lg:bottom-8',
  'bottom-right': 'bottom-4 right-4 lg:bottom-8 lg:right-8',
};

export default function ToastContainer({
  toasts,
  position = 'bottom-left',
  onRemoveToast,
}: ToastContainerProps) {
  if (toasts.length === 0) return null;

  return (
    <div
      className={`pointer-events-none fixed z-[9999] flex flex-col gap-3 ${positionClasses[position]}`}
    >
      {toasts.map((toast) => (
        <Toast key={toast.id} {...toast} onClose={onRemoveToast} />
      ))}
    </div>
  );
}
